// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"TalentSearch_mainSection__2KE4T","mainHeading":"TalentSearch_mainHeading__1FVum","cardContainer":"TalentSearch_cardContainer__3TPTq"};